/* unplugin-vue-components disabled */import script from "./Image.vue?vue&type=script&setup=true&lang=js"
export * from "./Image.vue?vue&type=script&setup=true&lang=js"

import "./Image.vue?vue&type=style&index=0&id=1fdf3f93&lang=stylus"

const __exports__ = script;

export default __exports__